import client from '@/api/client'

export async function requestFeature(feature: string) {
    return client.post(`/beta/request-feature/${feature}`)
}
